import { motion } from "framer-motion";
import { FaWhatsapp } from "react-icons/fa";

const PHONE = "919979068119";
const MESSAGE =
  "Hi! I'd like to enquire about event planning with Shree Event Planner.";

export default function WhatsAppButton() {
  const href = `https://wa.me/${PHONE}?text=${encodeURIComponent(MESSAGE)}`;
  return (
    <motion.a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      initial={{ opacity: 0, scale: 0.6, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 1.2, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.95 }}
      className="fixed bottom-6 right-6 md:bottom-8 md:right-8 z-[60] flex items-center gap-3 group"
      aria-label="Chat on WhatsApp"
    >
      {/* tooltip — desktop only */}
      <span
        className="hidden md:inline-flex items-center px-4 py-2 rounded-full glass-gold text-ivory text-sm font-light tracking-wide opacity-0 group-hover:opacity-100 transition-all duration-300 translate-x-4 group-hover:translate-x-0 pointer-events-none"
        data-testid="whatsapp-tooltip"
      >
        Chat on WhatsApp
      </span>

      {/* button */}
      <span
        className="relative w-14 h-14 md:w-16 md:h-16 rounded-full inline-flex items-center justify-center shadow-[0_8px_28px_rgba(37,211,102,0.45)] border border-white/15"
        style={{
          background:
            "radial-gradient(circle at 30% 30%, #4FE07A 0%, #25D366 50%, #128C7E 100%)",
        }}
      >
        <FaWhatsapp className="block text-white w-8 h-8 md:w-9 md:h-9" aria-hidden />
      </span>
    </motion.a>
  );
}
